export const movMimeTypes = [
  "image/mov",
  "image/x-quicktime",
  "video/quicktime",
  "video/x-quicktime",
];
